import config from '../../config';
import util from '../../utils';

export const CUSTOM_MESSAGE_TYPE = {
    TIMEOUT: 'TIMEOUT',
};

function computeTimeoutMessage(item, customerServiceAccount) {
    item.type = CUSTOM_MESSAGE_TYPE.TIMEOUT;
    item.showText = `会话对方可能正在忙碌尚未能回复您的信息，如果您有紧急事项，欢迎让客服小讼为您跟进`;
    item.title = `贴心提示`;
    item.primaryAction = {
        name: '联系小讼',
        actionName: 'createSession',
        arguments: [customerServiceAccount],
    };
    item.secondaryAction = {
        name: '结束会话',
        actionName: 'resetSession',
        arguments: [],
    };
}

export function computeMessage(
    message,
    chatType,
    userUID,
    userInfos,
    myInfo,
    isHistory,
    customerServiceAccount
) {
    let item = Object.assign({}, message);
    // 标记用户，区分聊天室、普通消息
    if (chatType === 'session') {
        if (item.flow === 'in') {
            if (item.type === 'robot' && item.content && item.content.msgOut) {
                // // 机器人下行消息
                // let robotAccid = item.content.robotAccid
                // item.avatar = this.robotInfos[robotAccid].avatar
                // item.isRobot = true
                // item.link = `#/namecard/${robotAccid}`
            } else if (item.from !== userUID) {
                item.avatar = (userInfos[item.from] && userInfos[item.from].avatar) || config.defaultUserIcon;
                item.link = `#/namecard/${item.from}`;
                // todo  如果是未加好友的人发了消息，是否能看到名片
            } else {
                item.avatar = myInfo.avatar;
            }
        } else if (item.flow === 'out') {
            item.avatar = myInfo.avatar;
        }
    } else {
        // 标记时间，聊天室中
        item.showTime = util.formatDate(item.time);
    }
    if (item.type === 'timeTag') {
        // 标记发送的时间
        item.showText = item.text;
    } else if (item.type === 'text') {
        // 文本消息
        // item.showText = util.escape(item.text)
        item.showText = item.text;
        if (/\[[^\]]+\]/.test(item.showText)) {
            // let emojiItems = item.showText.match(/\[[^\]]+\]/g)
            // emojiItems.forEach(text => {
            //   let emojiCnt = emojiObj.emojiList.emoji
            //   if (emojiCnt[text]) {
            //     item.showText = item.showText.replace(
            //       text,
            //       `<img class="emoji-small" src="${emojiCnt[text].img}">`
            //     )
            //   }
            // })
        }
    } else if (item.type === 'custom') {
        let content;
        try {
            content = JSON.parse(item.content);
        } catch (e) {
            console.error(`Custom message parse error, src content: "${item.content}"`);
            content = {};
            return;
        }
        // type 1 为猜拳消息
        if (content.type === 1) {
            let data = content.data;
            let resourceUrl = config.resourceUrl;
            // item.showText =
            //   `<img class="emoji-middle" src="${resourceUrl}/im/play-${data.value}.png">`
            item.type = 'custom-type1';
            item.imgUrl = `${resourceUrl}/im/play-${data.value}.png`;
            // type 3 为贴图表情
        } else if (content.customType === CUSTOM_MESSAGE_TYPE.TIMEOUT) {
            computeTimeoutMessage(item, customerServiceAccount);
        } else {
            item.showText = util.parseCustomMsg(item);
            if (item.showText !== '[自定义消息]') {
                item.showText += ',请到手机或电脑客户端查看';
            }
        }
    } else if (item.type === 'image') {
        // 原始图片全屏显示
        item.originLink = item.file.url;
    } else if (item.type === 'video') {
        // ...
    } else if (item.type === 'audio') {
        item.width = (5.3 + Math.round(item.file.dur / 1000) * 0.03).toFixed(2) + 'rem';
        item.audioSrc = item.file.mp3Url;
        item.showText = `<i>${Math.round(item.file.dur / 1000)}</i> 点击播放`;

        const { useDb = false } = window.nim;
        if (!isHistory && useDb) {
            item.unreadAudio = !item.localCustom;
        }
    } else if (item.type === 'file') {
        item.fileLink = item.file.url;
        item.showText = item.file.name;
    } else if (item.type === 'notification') {
        if (item.scene === 'team') {
            // item.showText = util.generateTeamSysmMsg(item)
        } else {
            // 对于系统通知，更新下用户信息的状态
            item.showText = util.generateChatroomSysMsg(item);
        }
    } else if (item.type === 'tip') {
        // 对于系统通知，更新下用户信息的状态
        item.showText = item.tip;
    } else if (item.type === 'robot') {
        // let content = item.content || {}
        // let message = content.message || []
        // if (!content.msgOut) {
        //   // 机器人上行消息
        //   item.robotFlow = 'out'
        //   item.showText = item.text
        // } else if (content.flag === 'bot') {
        //   item.subType = 'bot'
        //   message = message.map(item => {
        //     if (item.type === 'template') {
        //       // 在vuex(store/actions/msgs.js)中已调用sdk方法做了转换
        //       return item.content.json
        //     } else if (item.type === 'text' || item.type === 'answer') {
        //       // 保持跟template结构一致
        //       return [{
        //         type: 'text',
        //         text: item.content
        //       }]
        //     } else if (item.type === 'image') {
        //       // 保持跟template结构一致
        //       return [{
        //         type: 'image',
        //         url: item.content
        //       }]
        //     }
        //   })
        //   item.message = message
        // } else if (item.content.flag === 'faq') {
        //   item.subType = 'faq'
        //   item.query = message.query
        //   let match = message.match.sort((a, b) => {
        //     // 返回最匹配的答案
        //     return b.score - a.score
        //   })
        //   item.message = match[0]
        // }
    } else {
        item.showText = `[${util.mapMsgType(item)}],请到手机或电脑客户端查看`;
    }
    return item;
}
